import React from 'react';
import useAuth from "../../components/hooks/useAuth";
import {concepts} from "fearless-common";
import Tab from "react-bootstrap/Tab";
import GroupSubscriptionsOverview from "./subscriptions/GroupSubscriptionsOverview";
import MySubscriptionsOverview from "./subscriptions/MySubscriptionsOverview";
import {Loading} from "fearless-common-ui";
import Tabs from "../../components/layout/Tabs";
import {routes} from "../../utils";
import {useParams} from "react-router-dom";

const tabKeys = {
    my: 'my',
    teams: 'teams',
}

/**
 * Page to manage the logged-in user's subscription. The page contains multiple tabs.
 */
export default function UserSubscriptions() {
    const { user, reloadUser, isLoading  } = useAuth();
    const { tabId} = useParams();

    if (isLoading) return <Loading />;

    return user ? (
        <Tabs
            defaultActiveKey={tabId || tabKeys.my}
            id="user-subscription-tabs"
            className="mb-4"
            urlFormatter={routes.subscriptions}
        >
            <Tab eventKey={tabKeys.my} title={concepts.MySubscription}>
                {(!tabId || tabId === tabKeys.my) && <MySubscriptionsOverview user={user} reloadUser={reloadUser} />}
            </Tab>
            <Tab eventKey={tabKeys.teams} title={`${concepts.Group} ${concepts.Subscriptions}`}>
                {tabId === tabKeys.teams && <GroupSubscriptionsOverview />}
            </Tab>
        </Tabs>
    ) : null;
}
